<template>
  <div>
    <select
      v-for="searchCondition in searchConditionList"
      :key="searchCondition.value"
      :value="conditionSelected[searchCondition.value] ?? ''"
      :name="searchCondition.value"
      class="parts__select"
      :class="{ select_hidden: searchCondition.items.length === 0 }"
      @change="changeSelected(searchCondition.value, ($event.target as HTMLSelectElement).value)"
    >
      <option v-if="!isSelected && (props.isShowEmptyOption || searchCondition.items.length === 0)" value=""
        >選択してください</option
      >
      <option v-for="item in searchCondition.items" :key="item.value" :value="item.value">{{ item.name }}</option>
    </select>
  </div>
</template>

<script setup lang="ts">
import {
  baseSearchConditionList,
  getSearchCondition,
  BakuneTopProduct,
  SearchConditionKey,
  SearchCondition,
  SearchConditionSelected,
} from "~/utils/functions/howtochoose_recoverywear_sleepitem"

const props = withDefaults(
  defineProps<{
    products: BakuneTopProduct[]
    selected: SearchConditionSelected
    isShowEmptyOption?: boolean
  }>(),
  {
    isShowEmptyOption: false,
  },
)
const emit = defineEmits<{
  (
    e: "change",
    payload: { searchConditionSelected: SearchConditionSelected; selectedProducts: BakuneTopProduct[] },
  ): void
}>()

const conditionSelected = ref<SearchConditionSelected>({ ...props.selected })
const searchConditionList = ref<SearchCondition[]>([])
const selectedProducts = ref<BakuneTopProduct[]>([])
const isSelected = ref(false)

const changeSelected = (key: SearchConditionKey, value: string) => {
  const searchConditionSelected = { ...conditionSelected.value }
  let isClear = false
  const searchKeys = baseSearchConditionList.map((condition) => condition.value)
  for (const searchKey of searchKeys) {
    if (isClear) {
      searchConditionSelected[searchKey] = ""
      continue
    }
    if (searchKey === key) {
      // 今回選択した条件以降の条件をクリアして自動選択させて商品を一意にする
      searchConditionSelected[key] = value
      isClear = true
    }
  }
  setSearchCondition(searchConditionSelected)
  isSelected.value = true
}

const setSearchCondition = (searchConditionSelected: SearchConditionSelected, isAutoSelect: boolean = true) => {
  const {
    searchConditionList: newSearchConditionList,
    products: newSelectedProducts,
    selected: newSelected,
  } = getSearchCondition(props.products, searchConditionSelected, isAutoSelect)
  searchConditionList.value = newSearchConditionList
  if (
    searchConditionSelected.sex === "" &&
    searchConditionSelected.silhouette === "" &&
    searchConditionSelected.fabric === "" &&
    searchConditionSelected.sleevesAndPants === "" &&
    searchConditionSelected.detail === ""
  ) {
    searchConditionList.value = searchConditionList.value.map((condition) => {
      if (condition.value === "detail") {
        condition.items = []
      }
      return condition
    })
  }
  conditionSelected.value = newSelected
  selectedProducts.value = newSelectedProducts
  emit("change", { searchConditionSelected: newSelected, selectedProducts: newSelectedProducts })
}

watch(
  () => props.products,
  () => {
    setSearchCondition(conditionSelected.value, !props.isShowEmptyOption)
  },
  { immediate: true },
)

watch(
  () => props.selected,
  (newSelected) => {
    setSearchCondition(newSelected, !props.isShowEmptyOption)
  },
)
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
